import React from 'react';
import { makeStyles } from '@material-ui/styles';
import hash from '../../helpers/hash';

const useStyles = makeStyles(theme => ({
    
    root: props => ({
        height: props.vertical ? '100%' : (props.height || 5),
        margin: props.margin || 0,
        width: props.vertical ? (props.width || 5) : '100%',
        display: props.vertical ? 'inline-block' : 'block'
    })

}));

const Separator = (props) => {
    const classes = useStyles(props);
    const { vertical } = props;
    const customRoot = hash.walk('classes.root', props);
    return (<div className={customRoot || classes.root}></div>)
} 

export default Separator;


// WEBPACK FOOTER //
// ./src/client/components/Separator.js